import { render, staticRenderFns } from "./activity_result_add.vue?vue&type=template&id=0cd858f4&scoped=true&"
import script from "./activity_result_add.vue?vue&type=script&lang=js&"
export * from "./activity_result_add.vue?vue&type=script&lang=js&"
import style0 from "./activity_result_add.vue?vue&type=style&index=0&id=0cd858f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd858f4",
  null
  
)

export default component.exports